import {Component, Input, OnInit} from '@angular/core';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {DocumentModel} from '../../models/document.model';
import {LoadingController, ModalController} from '@ionic/angular';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {TestConnectionService} from '../../services/test-connection.service';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {GenerateDateFromTimestampService} from '../../services/generate-date-from-timestamp.service';
import {ConfigurationModel} from '../../models/configuration.model';
import {FindProductPriceService} from '../../services/find-product-price.service';
import {FindEquipmentPriceService} from '../../services/find-equipment-price.service';

@Component({
    selector: 'app-product-multi-select',
    templateUrl: './product-multi-select.component.html',
    styleUrls: ['./product-multi-select.component.scss'],
})
export class ProductMultiSelectComponent implements OnInit {
    @Input() document: DocumentModel;
    @Input() behaviour: string;
    productList: DetaillineDTOModel[] = [];
    sparesList: DetaillineDTOModel[] = [];
    queryText = '';
    showOnlySpares: boolean;
    loading: any;
    lastUpdate: string;
    configuration: ConfigurationModel;

    constructor(private modalController: ModalController,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames,
                private testConnectionService: TestConnectionService,
                private refreshdatabaseService: RefreshdatabaseService,
                private loadingController: LoadingController,
                private generateDateFromTimestamp: GenerateDateFromTimestampService,
                private findProductPriceService: FindProductPriceService,
                private findEquipmentPriceService: FindEquipmentPriceService) {
    }

    ngOnInit() {
        this.showOnlySpares = this.document.documentType === 7 && this.behaviour.toLowerCase() !== 'fuel';
        this.configuration = this.stateManagerService.getCollection(this.collectionsNames.CONFIGURATION);
        this.formatLastUpdateDate();
        this.loadProducts();
    }

    loadProducts() {
        console.log(this.showOnlySpares);
        if (this.showOnlySpares) {
            const tempSparesList = this.stateManagerService.getCollection(this.collectionsNames.SPARESUSEDINWS);
            this.sparesList = JSON.parse(JSON.stringify(tempSparesList));
            console.log("SparesList");
            console.log(this.sparesList);
        } else {
            const tempProductList = this.stateManagerService.getCollection(this.collectionsNames.PRODUCTTYPE);
            this.productList = JSON.parse(JSON.stringify(tempProductList));
        }
        this.filterProducts();
    }

    async fetchProducts(event: any) {
        try {
            await this.testConnectionService.pingServer();
            await this.refreshdatabaseService.refreshProductResource();
            this.loadProducts();
            await event.target.complete();
        } catch (e) {
            await event.target.complete();
        }
    }

    addProducts() {
        this.insertLinesIntoDocument(this.productList);
        this.insertLinesIntoDocument(this.sparesList);
        this.modalController.dismiss();
    }

    async insertLinesIntoDocument(details: DetaillineDTOModel[]) {
        for (const line of details) {
            if (line.isChecked) {
                const tempLine = JSON.parse(JSON.stringify(line)) as DetaillineDTOModel;
                tempLine.comment = tempLine.description;
                tempLine.qty = (tempLine.qty && tempLine.qty > 0) ? tempLine.qty : 1;
                delete tempLine.isChecked;
                await this.findProductPriceService.findFinalPriceAndDiscount(tempLine, this.document);
                this.document.detailLines.push(tempLine);
            }
        }
    }

    cancelModal() {
        this.modalController.dismiss();
    }

    formatLastUpdateDate() {
        this.lastUpdate = this.generateDateFromTimestamp.formatLastUpdateDate(this.configuration.productDateTime);
    }

    private filterProducts() {
        if (!this.behaviour) {
            return;
        }
        if (this.behaviour.toLowerCase() === 'parts') {
            this.sparesList = this.sparesList.filter(line => {
                return !line.fuelProductType;
            });
            this.productList = this.productList.filter(line => {
                return !line.fuelProductType;
            });
        }
        if (this.behaviour.toLowerCase() === 'fuel') {
            this.productList = this.productList.filter(line => {
                return line.fuelProductType;
            });
        }
    }
}
